import React, { useMemo, useState } from 'react';

import { listAllIncidentWorkflowTriggersForServices } from 'src/lib/api/pagerdutyIncidentWorkflowHelpers';
import { NoAccessToIncidentWorkflowsError } from 'src/lib/error';

import { useSelectedServices } from 'src/views/Admin/Modals/EditRuleModal/RuleForm/components/RuleFormContext';
import Field from 'src/views/components/Form/Field';
import NoAccessToIncidentWorkflowsMessage from 'src/views/components/messages/NoAccessToIncidentWorkflowsMessage';
import NoIncidentWorkflowsMessage from 'src/views/components/messages/NoIncidentWorkflowsMessage';
import { PdIncidentWorkflowTriggerSelect } from 'src/views/components/select';

export const name = 'pd_run_incident_workflow';
export const label = 'Run Workflow';
export const type = 'incident_create,incident_update';

export const AdditionalParams = ({
  name,
  values = {},
  targetService,
  touched = false,
  errors = null,
  onChange,
  onBlur,
}) => {
  const [errorComponent, setErrorComponent] = useState(null);
  const services = useSelectedServices();

  const optionSources = useMemo(async () => {
    try {
      let serviceIds = [];
      if (services && services.length > 0) {
        if (name.includes('autocreate_incidents_config')) {
          serviceIds = targetService ? [targetService.id] : [services[0].id];
        } else {
          serviceIds = services.map(s => s.id);
        }
      }

      const triggers = await listAllIncidentWorkflowTriggersForServices(serviceIds, {
        trigger_type: 'manual',
        sort_by: 'workflow_name'
      });

      return triggers.map(t => ({
        label: t.workflow_name,
        id: t.id,
        workflow_id: t.workflow_id,
        description: t.workflow.description
      }));
    } catch (e) {
      if (e instanceof NoAccessToIncidentWorkflowsError) {
        setErrorComponent(<NoAccessToIncidentWorkflowsMessage/>);
        return [];
      } else {
        setErrorComponent(true);
        throw e;
      }
    }
  }, [targetService, services, name]);

  let noOptionsMessageProp = {};
  if (errorComponent === null) {
    noOptionsMessageProp = { noOptionsMessage: () => {
      return <NoIncidentWorkflowsMessage utmContent = "run_workflow_action_no_options" />;
    } };
  }

  return (
    <Field label="Select Workflow to run">
      <PdIncidentWorkflowTriggerSelect
        {...noOptionsMessageProp}
        optionSources={optionSources}
        name={`${name}.pd_run_incident_workflow`}
        value={values.pd_run_incident_workflow}
        errorComponent={errorComponent}
        onChange={onChange}
        onBlur={onBlur}
        isMulti
      />
    </Field>
  );
};
